import { Image, type ImageProps } from '@mantine/core';
import NextImage, { type ImageProps as NextImageProps } from 'next/image';

type MantineNextImageProps = Omit<ImageProps, 'component' | 'src' | 'alt'> & {
  src: NextImageProps['src'];
  alt: NextImageProps['alt'];
  onLoad?: NextImageProps['onLoad'];
  onError?: NextImageProps['onError'];
  priority?: NextImageProps['priority'];
  loading?: NextImageProps['loading'];
  width?: number;
  height?: number;
  sizes?: string;
  unoptimized?: boolean;
};

export function MantineNextImage({
  width = 1600,
  height = 900,
  sizes = '100vw',
  unoptimized = true,
  src,
  alt,
  onLoad,
  onError,
  priority,
  loading,
  ...props
}: MantineNextImageProps) {
  return (
    <Image
      component={NextImage}
      src={src}
      alt={alt}
      onLoad={onLoad}
      onError={onError}
      priority={priority}
      loading={loading}
      width={width}
      height={height}
      sizes={sizes}
      unoptimized={unoptimized}
      {...props}
    />
  );
}
